import React from 'react';
import { styled } from '@mui/material';
import { pureWhite, bentoTeal2 } from './colors';
import type { ToothState } from './AddServices.types';

const StyleTooth = styled('div')<{ selected: boolean }>(({ selected }) => ({
  width: 40,
  height: 40,
  textAlign: 'center',
  color: selected ? pureWhite : bentoTeal2,
  backgroundColor: selected ? bentoTeal2 : pureWhite,
  border: `1px solid ${bentoTeal2}`,
  borderRadius: '50%',
  cursor: 'pointer',
  fontSize: 14,
  padding: '9px 0',
}));

interface ToothProps {
  tooth_select: boolean | ToothState;
  num: number | string;
  onToothClick: (num: number | string) => void;
}

function Tooth({ tooth_select: toothSelect, num, onToothClick }: ToothProps) {
  const isSelected = typeof toothSelect === 'object' ? toothSelect.selected : toothSelect;

  return (
    <StyleTooth selected={isSelected} onClick={() => onToothClick(num)}>
      {num}
    </StyleTooth>
  );
}

export default Tooth;
